export * from './types';
import type {WebflowCssProperty} from '@packages/systems/core/utils/WebflowCssSubset';
import type {SelectorChunk} from './types';
import type {StyleBlockId} from '@packages/systems/style-legacy/records';
import type {BreakpointID} from '@packages/systems/style/types';
import type {
  PseudoStateKey,
  CustomNodeStateKey,
} from '@packages/systems/core/utils/StyleTypes';
import {VariantStateKey} from '@packages/systems/style-legacy/selectors';
import {Qualified} from '@packages/systems/wfdl-Qualified';

export const STYLE_BLOCK_STYLE_RULE = 'STYLE_BLOCK_STYLE_RULE' as const;
export const DEFAULT_STYLE_RULE = 'DEFAULT_STYLE_RULE' as const;
export const LOCAL_STYLE_RULE = 'LOCAL_STYLE_RULE' as const;

export type StyleRuleType =
  | typeof STYLE_BLOCK_STYLE_RULE
  | typeof DEFAULT_STYLE_RULE
  | typeof LOCAL_STYLE_RULE;

export type StyleRule = {
  chunks: null | Array<SelectorChunk>;
  foreign: boolean;
  inherited: boolean;
  inheritedDistance: number;
  mediaQuery: BreakpointID;
  mint: boolean;
  pseudoState: null | PseudoStateKey;
  variantState: null | VariantStateKey;
  score: number;
  styleBlock: StyleBlockId | null;
  styleLess: string;
  customNodeState: CustomNodeStateKey | null | undefined;
  type: StyleRuleType;
  styles: Partial<Record<WebflowCssProperty, any>>;
  origin: null | Qualified<StyleBlockId>;
};
